import React from 'react';
import { Icons, PrimaryButton } from '../../../../components';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import brandsBanner from './brandsBanner.png';

import css from './SectionBrandHero.module.css';

function BrandsInlineBanner({ intl, onRedirectPage }) {
  return (
    <div className={classNames(css.howItWorks, css.brandInlineBanner)}>
      <div className={css.startContent}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>
              <FormattedMessage id="BrandsInlineBanner.title" />
            </h2>
            <p>
              <FormattedMessage
                id="BrandsInlineBanner.description"
                values={{
                  nilPremier: intl.formatMessage({
                    id: 'BrandsInlineBanner.nilPremier',
                  }),
                }}
              />
            </p>
            <PrimaryButton
              className={css.viewbtn}
              type="button"
              onClick={() => onRedirectPage('SubscriptionPage')}
            >
              <FormattedMessage id="BrandsInlineBanner.button" />
            </PrimaryButton>
          </div>
        </div>
      </div>
      <div className={css.endContent}>
        <img src={brandsBanner} alt="Brands Banner" className={css.brandsBanner} />
      </div>
    </div>
  );
}

export default BrandsInlineBanner;
